const customBenchmarkPrefix = '__';

export const startBenchmark = (measureName: string): void => {
  performance.mark(`${customBenchmarkPrefix}${measureName}:start`);
};

export const endBenchmark = (measureName: string): void => {
  const customMeasureName = `${customBenchmarkPrefix}${measureName}`;
  performance.mark(`${customMeasureName}:end`);
  performance.measure(
    customMeasureName,
    `${customMeasureName}:start`,
    `${customMeasureName}:end`
  );
};

export const initPerformanceObserver = (): void => {
  const po = new PerformanceObserver((list) => {
    const relevantEntries = [];
    for (const entry of list.getEntries()) {
      const entryObj = entry.toJSON();
      // Log the entry and all associated details.
      if (entryObj.name.includes(customBenchmarkPrefix)) {
        relevantEntries.push({
          ...entryObj,
          endTime: entryObj.startTime + entryObj.duration,
        });
      }
    }

    if (relevantEntries.length) {
      // eslint-disable-next-line no-console
      console.log(relevantEntries.sort((a, b) => a.endTime - b.endTime));
    }
  });
  // Start listening for `measure` entries to be dispatched.
  po.observe({ type: 'measure', buffered: true });
};
